export default {
  data() {
    return {

    }
  },
  methods: {
    estadoTarjeta(status) {
      return { pending: "Pendiente", active: "Activa", cancelled: "Cancelada" }[status] || status;
    },
    colorEstadoTarjeta(status) {
      return { pending: "warning", active: "success", cancelled: "error" }[status] || "grey";
    },
    executeVerMovimientos(item) {
      this.$refs.movimientosTarjeta.renderItem(item);
    },
    // Cuánto dinero hay en tarjetas sin gastar, cuánto vence y el detalle por tarjeta.
    executeVerSaldos() {
      this.$refs.saldosTarjetas.abrir();
    },
    executeActivateGiftCard(item) {
      this.$refs.activateGiftCard.renderItem(item);
    },
    // La tarjeta en PDF (valor, QR y código): el servidor solo la entrega al activarla o con permiso para ver el código.
    async executeGeneratePdf(item) {
      const res = await this.$http.get("api/v1/gift-card/" + item.id + "/pdf", null, true, true);
      if (res && res.success) {
        window.open(this.$http.getBaseUrlPublicFiles() + "tmp/" + res.item);
      }
    },
    refreshList() {
      this.search(this.form, this.options.page);
    }
  }
}
